import React from "react";
import PropTypes from "prop-types";
import { Metric } from "@tremor/react";
import { Typography } from "@material-tailwind/react";

export default function MetricPair({ ChartComponent, additionalInfo, additionalMetric, rightSlot }) {
  const rhs = rightSlot ?? (
    <Metric className="metric-auto-height">{additionalMetric}</Metric>
  );

  // Only render the Typography if we have content to display.
  const showInfo = additionalInfo != null && additionalInfo !== false && additionalInfo !== "";

  return (
    <div className="flex flex-col sm:flex-row pt-2">
      <div className="sm:w-1/2 flex items-center justify-center sm:pr-4 pr-10">
        {ChartComponent}
      </div>
      <div className="sm:w-1/2 border-t sm:border-t-0 sm:border-l-2 flex flex-col items-center justify-center sm:pl-4 pl-10 pt-3 sm:pt-0">
         {showInfo && (
            <Typography variant="h3" className="w-full text-center">
              {additionalInfo}
            </Typography>
          )}
        {rhs}
      </div>
    </div>
  );
}

MetricPair.propTypes = {
  ChartComponent: PropTypes.element.isRequired,
  // additionalInfo is required only if rightSlot is missing
  additionalInfo: (props, propName, componentName) => {
    if (!props.rightSlot && (props[propName] === undefined || props[propName] === null)) {
      return new Error(
        `\`${propName}\` is required in \`${componentName}\` when \`rightSlot\` is not provided.`
      );
    }
    return null;
  },
  rightSlot: PropTypes.node,
  // additionalMetric is required only if rightSlot is missing
  additionalMetric: (props, propName, componentName) => {
    if (!props.rightSlot && (props[propName] === undefined || props[propName] === null)) {
      return new Error(
        `\`${propName}\` is required in \`${componentName}\` when \`rightSlot\` is not provided.`
      );
    }
    return null;
  },
};